import "./PopupContainer.css";

import { CssClassNameBuilder } from '../../../utils/CssClassNameBuilder';
import { useMemo } from "react";

interface IPopupProps {
  children: React.ReactNode;
  className?: string;
}

export function PopupContainer(props: IPopupProps) {

  const popupContainerCss = useMemo(() => {
    return CssClassNameBuilder.new()
        .add("popup-container")
        .addConditional(props.className, props.className)
        .build()
  }, [props.className]);

  return (
    <div className={popupContainerCss}>
        {props.children}
    </div>

  );
}
